export enum ProfileDetailModeEnum {
    Admin = 0,
    AdminEdit = 1,
    ProfileCreate = 2,
    ProfileEdit = 3,
    ConsultantEdit=4
}
